module.exports = __webpack_public_path__ + "img/img-02@2x.769cc7ad.png";